<ng-container *ngIf="!this.isPrimeNg; else PrimeNg">
    <div class="form-group row mt-2">
        <label class="col-sm-12" for="otp">
            <b>Enter OTP*</b>
        </label>
        <div class="col-sm-12 col-md-12 col-lg-9">
            <input name="otp" type="text" class="form-control rounded-pill input-type-number m-0" id="otp"
                aria-describedby="otp" placeholder="Please enter 6 digit OTP here" (keypress)="only_number($event)"
                [(ngModel)]="this.otp_data.OTP_validate_api.token" #otp="ngModel" maxlength="6"
                [class.form-input-error]="(otp.invalid && (otp.dirty || otp.touched)) && (otp.errors?.required || otp.errors?.FieldValidator )"
                [class.form-input-success]="(!otp.invalid && (otp.dirty || otp.touched)) && !(otp.errors?.required && otp.errors?.FieldValidator )"
                required>
        </div>
        <div *ngIf="otp?.invalid && (otp?.dirty || otp?.touched)" class="col-sm-12 col-lg-9 pl-2">
            <div *ngIf="otp.errors?.required" class="col-sm-12 alert alert-danger m-2" role="alert">
                OTP is required.
            </div>
            <div *ngIf="otp.errors?.min || otp.errors?.max" class="col-sm-12 alert alert-danger m-2" role="alert">
                OTP should be of 6 digits.
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <ng-container *ngIf="this.otp_data.OTP_validate_api.can_resend">
                <p>OTP not received yet? <a class="egd-theme" role="button" (click)="otpResend()">Resend OTP</a>
                </p>
            </ng-container>
            <ng-container *ngIf="!this.otp_data.OTP_validate_api.can_resend">
                You can resend otp in {{this.otp_data.OTP_validate_api.countdown}}
            </ng-container>
        </div>
    </div>
</ng-container>

<ng-template #PrimeNg>
    <div class="ui-g mt-2">
        <label class="ui-g-12" for="otp">
            <b>Enter OTP*</b>
        </label>
        <div class="ui-g-12">
            <input pInputText [pKeyFilter]="reg_exp.number_input" name="otp" type="text" class="otpPrimeNgInput"
                id="otp" aria-describedby="otp" placeholder="Please enter 6 digit OTP here"
                [(ngModel)]="this.otp_data.OTP_validate_api.token" #otp="ngModel" maxlength="6"
                [class.form-input-error]="(otp.invalid && (otp.dirty || otp.touched)) && (otp.errors?.required || otp.errors?.FieldValidator )"
                [class.form-input-success]="(!otp.invalid && (otp.dirty || otp.touched)) && !(otp.errors?.required && otp.errors?.FieldValidator )"
                required>
        </div>
        <div *ngIf="otp?.invalid && (otp?.dirty || otp?.touched)" class="ui-g-12 pl-2">
            <div *ngIf="otp.errors?.required" class="ui-g-12 alert alert-danger m-2" role="alert">
                OTP is required.
            </div>
            <div *ngIf="otp.errors?.min || otp.errors?.max" class="ui-g-12 alert alert-danger m-2" role="alert">
                OTP should be of 6 digits.
            </div>
        </div>
    </div>
    <div class="ui-g">
        <div class="ui-g-7 text-left">
            <p>OTP not received yet? </p>
        </div>
        <div class="ui-g-5 text-right">
            <p>
                <ng-container *ngIf="this.otp_data.OTP_validate_api.can_resend">
                    <a class="egd-theme click_fn" (click)="otpResend()">Resend OTP</a>
                </ng-container>

                <ng-container>
                    {{this.otp_data.OTP_validate_api.countdown}}
                </ng-container>
            </p>
            <!-- <p></p> -->
        </div>
    </div>
</ng-template>